import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const postalCodeSchema = string().label('Postal Code');

export const PostalCodeField = (props: FieldInputProps) => <HookFormField.Input label="Postal Code" {...props}/>;